import React from 'react';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Coming Soon</h1>
        <p>We are working hard to bring you an amazing experience. Stay tuned!</p>
      </header>
    </div>
  );
}

export default App;
